const GameOnlinePlayerReducers = (state = {}, action) => {
  switch (action.type) {
    case "storeGameOnlinePlayer":
      return action.payload;
    default:
      return state;
  }
};
export default GameOnlinePlayerReducers;
